import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DealerDetail from './components/DealersDetails.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageDealer',
  components: {
    DealerDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;